import { BUGHERD_SRC, PROD_HOSTNAME } from "@abbvie-epi/common/constants";
import { Component, OnInit } from "@angular/core";
import { combineLatest, fromEvent, Observable } from "rxjs";
import { SpecialtyService } from "./services/specialty.service";
@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit {
    public hcpModalIsShowing: boolean;

    private resizeObservable$: Observable<Event> = new Observable<Event>();
    private orientationChangeObservable$: Observable<Event> = new Observable<Event>();

    constructor(private specialtyService: SpecialtyService) {
        // Only show bugherd if not on prod
        if (!this.isProd()) {
            this.loadBugherdScriptInProd();
        }
    }

    ngOnInit() {
        this.setupViewableContainerCssVar();

        this.specialtyService.getHcpModalStatus().subscribe((value) => {
            this.hcpModalIsShowing = value;
        });

        this.resizeObservable$ = fromEvent(window, "resize");
        this.orientationChangeObservable$ = fromEvent(window, "orientationchange");

        combineLatest([this.orientationChangeObservable$, this.resizeObservable$]).subscribe(() => {
            this.setupViewableContainerCssVar();
        });
    }

    private setupViewableContainerCssVar() {
        const viewableHeight = `${window.innerHeight}px`;
        const rootEl = document.documentElement;
        rootEl.style.setProperty("--app-height", viewableHeight);
    }

    private loadBugherdScriptInProd(): void {
        const node = document.createElement("script");
        node.src = BUGHERD_SRC;
        node.type = "text/javascript";
        node.async = true;
        // append to head of document
        document.getElementsByTagName("head")[0].appendChild(node);
    }

    private isProd(): boolean {
        return window.location.hostname.endsWith(PROD_HOSTNAME);
    }
}
